var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chatroom"}},[_c('RoomDropdown',{attrs:{"room-id":1}}),_vm._v(" "),_c('RoomDropdown',{attrs:{"room-id":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }